<div class="workflow-details modal-view" c-toggle="showActivity">
    <div ui-view></div>
</div>